import React from 'react'
import banner from '../../assets/banner1.jpg'
import '../../Styles/Banner.css'

const Banner = () => {
    return (
        <div>
            <img src={banner} alt="" />
        </div>
    )
}

export default Banner
